export const messages = {
  error:
    'Die Verifizierung deines Benutzerkontos ist leider fehlgeschlagen. Ein neuer Verifizierungslink wurde an deine E-Mail-Adresse gesendet. Bitte überprüfe dein Postfach.',
  success:
    'Dein Benutzerkonto wurde erfolgreich verifiziert. Du kannst dich jetzt mit deinen Zugangsdaten anmelden und alle Funktionen unseres Dienstes nutzen.',
  pending: 'Dein Benutzerkonto wird zurzeit verifiziert.',
};
